import { Stack } from 'react-bootstrap';

interface IAppliedFiltersSection {
    children: React.ReactNode;
    onToggleFilterPane: () => void;
}

export function AppliedFiltersSection(props: IAppliedFiltersSection) {
    const { children, onToggleFilterPane } = props;

    return (
        <Stack
            direction="horizontal"
            style={{ alignItems: 'start', paddingBottom: 10, paddingTop: 10 }}
        >
            <button
                className="btn btn-no-bg text-gray"
                onClick={onToggleFilterPane}
                style={{ marginLeft: -12 }}
            >
                <Stack direction="horizontal" gap={1}>
                    <i className="fal fa-filter" />
                    <span>Filters</span>
                </Stack>
            </button>
            {children}
        </Stack>
    );
}
